import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { HydraCollection } from '../hydra/hydra-collection';
import { OrganisationModel } from '../models/organisation/organisation.model';
import { OrganisationAddressModel } from '../models/organisation/organisation-address';
import { map } from 'rxjs/operators';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class OrganisationApiService extends ApiService {
  readonly resourcePath = 'organisations';

  list(filters: Record<string, string> = {}): Observable<HydraCollection<OrganisationModel>> {
    return this.restList<OrganisationModel>(filters);
  }

  create(data:object){
    return this.restCreate<OrganisationModel>(data);
  }

  get(id: string): Observable<OrganisationModel> {
    return this.restRead<OrganisationModel>(id);
  }

  getAddresses(id:string):Observable<HydraCollection<OrganisationAddressModel>>{
    return this.http.get<HydraCollection<OrganisationAddressModel>>(this.resourceUrl + "/"+id+"/addresses").pipe(
      map(response => new HydraCollection<OrganisationAddressModel>(response))
    );
  }

  leave(id:string){
   // return this.http.delete()
  }

  uploadFile(data:FormData){
    return this.http.post(this.apiUrl+'/file_objects', data, {
      reportProgress: true,
      observe: 'events',
    });
  }

  updateFile(id:string,data:FormData){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/merge-patch+json'
      })
    };
    return this.http.patch<any>(this.apiUrl+'/file_objects/'+id, data, httpOptions);
  }


  update(id: string, data: object): Observable<OrganisationModel> {
    return this.restUpdate<OrganisationModel>(id, data);
  }

}
